export const CATEGORY_RECOMMENDED_PERCENT = {
	'آموزش': { start: 50, end: 70 },
	'تفریحی و ورزشی': { start: 20, end: 40 },
	'تور و سفر': { start: 20, end: 40 },
	'خدمات': { start: 50, end: 70 },
	'رستوران و کافی شاپ': { start: 20, end: 40 },
	'زیبایی و آرایشی': { start: 40, end: 60 },
	'سلامتی و پزشکی': { start: 40, end: 60 },
	'هنر و تئاتر': { start: 30, end: 50 },
};

export const DEFAULT_CATEGORY_RECOMMENDED_PERCENT = { start: 30, end: 50 };
